import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { errText } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [korwilFilter, setKorwilFilter] = useState("");
  const [kordaFilter, setKordaFilterState] = useState(
    () => localStorage.getItem("pyx_korda") || ""
  );

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pyx_token", data.access_token);
    localStorage.removeItem("pyx_korda");
    setKordaFilterState("");
    setUser(data.user);
    setKorwilFilter(data.user.role === "KORWIL" ? data.user.korwil : "");
    return data.user;
  }, []);

  // Pemilihan Korda hanya untuk SUPER_ADMIN. Reload penuh agar semua modul
  // memuat ulang data pada tenant yang dipilih.
  const setKordaFilter = useCallback((korda) => {
    if (korda) localStorage.setItem("pyx_korda", korda);
    else localStorage.removeItem("pyx_korda");
    setKordaFilterState(korda);
    window.location.reload();
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("pyx_token");
    localStorage.removeItem("pyx_korda");
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        korwilFilter,
        setKorwilFilter,
        kordaFilter,
        setKordaFilter,
        errText,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
